import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';
import { Store } from '@ngrx/store';

@Component({
  // eslint-disable-next-line
  selector: 'ui-kit-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends UIKitBaseComponent implements AfterContentInit {
  @Input() label?: string;
  @Input() toggle?: boolean;
  @Input() showLabel = true;

  private indeterminate = false;

  constructor(
    private element: ElementRef<HTMLElement>,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<any>,
  ) {
    super();
  }

  ngAfterContentInit(): void {
    this.setInputIndeterminate(this.indeterminate);
  }

  setInputIndeterminate(value: boolean) {
    const input = this.element.nativeElement.querySelector('input');
    if (input) {
      input.indeterminate = value;
    }
  }
}
